export const pages = [
  { index: 0, name: 'Home', route: '/' },
{ index: 1, name: 'overview.md', route: '/overview' },
{ index: 2, name: 'skills.md', route: '/skills' },
{ index: 3, name: 'experience.md', route: '/experience' },
{ index: 4, name: 'education.md', route: '/education' },
{ index: 5, name: 'projects.md', route: '/projects' },
{ index: 6, name: 'certificates.md', route: '/certificates' },
];
